export const _LOAD_PUZZLE_WALLS_MODEL_ = 'Load:PuzzleWallsPuzzle';

export const CELL = {
  id: null,
  positionx: 0,
  positiony: 0,
  shape: null,
  value: null,
  filled: true,
  color: null,
  direction: null,
  isBlocked: false,
};

export const SETTINGS = {
  showAnswer: true,
  colored: true,
  pathWeight: 'normal',
  density: 25,
};

export const MODEL = {
  id: null,
  name: null,
  slug: null,
  type_id: 8,
  rows: 10,
  columns: 10,
  settings: { ...SETTINGS },
  table: [],
};

export const CELL_SIZE = 60;
